"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntermediateCatchEvent = void 0;
const Constants_1 = require("../Constants");
const EventBase_1 = require("./EventBase");
/**
 * Describes a BPMN IntermediateThrowEvent.
 *
 * These are used to wait for events during ProcessModel execution.
 *
 * The only exception is the IntermediateTimerCatchEvent, which is used to halt
 * the execution for a given amount of time.
 */
class IntermediateCatchEvent extends EventBase_1.Event {
    get bpmnType() {
        return Constants_1.BpmnType.intermediateCatchEvent;
    }
    get eventType() {
        const eventIsMessageEvent = this.messageEventDefinition !== undefined;
        if (eventIsMessageEvent) {
            return Constants_1.EventType.messageEvent;
        }
        const eventIsSignalEvent = this.signalEventDefinition !== undefined;
        if (eventIsSignalEvent) {
            return Constants_1.EventType.signalEvent;
        }
        const eventIsTimerEvent = this.timerEventDefinition !== undefined;
        if (eventIsTimerEvent) {
            return Constants_1.EventType.timerEvent;
        }
        const eventIsLinkEvent = this.linkEventDefinition !== undefined;
        if (eventIsLinkEvent) {
            return Constants_1.EventType.linkEvent;
        }
        return undefined;
    }
}
exports.IntermediateCatchEvent = IntermediateCatchEvent;
//# sourceMappingURL=IntermediateCatchEvent.js.map